import React, { Component } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
} from "@mui/material";
import Sidebar from "../Sidebar";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import base from "../base.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from 'moment'

const drawerWidth = 80;
export class EditFranchise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      franchise_company_name: "",
      franchise_date: "",
      franchise_applicant_name: "",
      current_job_or_bussiness: "",
      applicant_phone_no: "",
      investment_buget: 0,
      current_income: 0,
      contact_email_id: "",
      frenchise_area_pincode: "",
      frenchise_address: "",
      frenchise_password : "",

      is_switch_case: true,
      is_vendor_delete: false,
    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

 

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

 

  handleChangeee = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };




  updateFrenchise = () => {
 if( this.state.franchise_company_name!== "" &&
      this.state.franchise_date!== "" &&
      this.state.franchise_applicant_name!== "" &&
      this.state.current_job_or_bussiness!== "" &&
      this.state.applicant_phone_no!== "" &&
      this.state.investment_buget > 0 &&
      this.state.current_income > 0 &&
      this.state.contact_email_id!== "" &&
      this.state.frenchise_area_pincode!== "" &&
      this.state.frenchise_address!== "" &&
      this.state.frenchise_password !== ""){

      let id= this.props.param.id.replace(/:/g, "");
    fetch(`${base.base_url}/admin/frenchise/updateFranchise`, {
      headers: {
        "content-type": "application/json",
      },
        method: "put",
        body: JSON.stringify({
        franchise_company_name: this.state.franchise_company_name,
        franchise_date: this.state.franchise_date,
        franchise_applicant_name: this.state.franchise_applicant_name,
        current_job_or_bussiness: this.state.current_job_or_bussiness,
        applicant_phone_no: this.state.applicant_phone_no,
        investment_buget: this.state.investment_buget,
        current_income: this.state.current_income,
        contact_email_id: this.state.contact_email_id,
        frenchise_area_pincode: this.state.frenchise_area_pincode,
        frenchise_address: this.state.frenchise_address,
        frenchise_password : this.state.frenchise_password,
        f_id : id
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then(() => {
      this.props.navigate('/frenchiseList')
      });

    }else{
   alert("fill all fields")

    }
  };


  componentDidMount(){
    this.retriveFrechiseDetails();
  }


  retriveFrechiseDetails=()=>{
    let id= this.props.param.id.replace(/:/g, "");
   
       this.setState({is_loader_open : true},()=>{
          fetch(
             `${base.base_url}/admin/frenchise/retriveSingleFrenchiseDetials/:${id}`,
             {
               headers: {
                 "content-type": "application/json",
               },
               method: "get",
             }
           )
             .then((res) => {
               return res.json();
             })
             .then((result) => {
               this.setState({
               
       franchise_company_name : result.data.franchise_company_name,
      franchise_date: moment(result.data.franchise_date).format('YYYY-MM-DD'),
      franchise_applicant_name: result.data.franchise_applicant_name,
      current_job_or_bussiness: result.data.current_job_or_bussiness,
      applicant_phone_no: result.data.applicant_phone_no,
      investment_buget: result.data.investment_buget,
      current_income: result.data.current_income,
      contact_email_id: result.data.contact_email_id,
      frenchise_area_pincode: result.data.frenchise_area_pincode,
      frenchise_address: result.data.frenchise_address,
      frenchise_password : result.data.frenchise_password,
        is_loader_open  :false
               })
  
              })
            })
  
  }
  

  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                height: 47,
                //  width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>
                Edit Frenchise Details
              </Typography>

              <Link to="/frenchiseList">
                <Button
                  variant="contained"
                  size="samll"
                  startIcon={
                    <FormatListNumberedOutlinedIcon
                      sx={{ height: 20, width: 20 }}
                    />
                  }
                  disableElevation
                  sx={{
                    height: 25,
                    fontSize: 13,
                    textTransform: "none",
                    backgroundColor: "#288ade",
                    mr: 1,
                  }}
                >
                  Franchise List
                </Button>
              </Link>
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "block" : "none",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Personal Information (Franchise)
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Frenchise Company Name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Frenchise Company Name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="franchise_company_name"
                          value={this.state.franchise_company_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Franchise Date
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          type="date"
                          placeholder="Franchise Date"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="franchise_date"
                          value={this.state.franchise_date}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Applicant Name
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Applicant Name"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="franchise_applicant_name"
                          value={this.state.franchise_applicant_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Current Job or Bussiness
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Current Job or Bussiness"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="current_job_or_bussiness"
                          value={this.state.current_job_or_bussiness}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Applicant Phone No
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Applicant Phone No"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="applicant_phone_no"
                          value={this.state.applicant_phone_no}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Investment Buget
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Investment Buget"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="investment_buget"
                          value={this.state.investment_buget}
                          onChange={(e)=>this.setState({investment_buget : e.target.value >= 0 ? e.target.value  : 0 })}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Currrent Income
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Currrent Income"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="current_income"
                          value={this.state.current_income}
                          onChange={(e)=>this.setState({current_income : e.target.value >= 0 ? e.target.value  : 0 })}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Contact Email Id
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Contact Email Id"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="contact_email_id"
                          value={this.state.contact_email_id}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Frenchise Address
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Frenchise Address"
                          fullWidth
                          multiline
                          minRows={3}
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="frenchise_address"
                          value={this.state.frenchise_address}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Area Pincode
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Pine code"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="frenchise_area_pincode"
                          value={this.state.frenchise_area_pincode}
                          onChange={this.handleChange}
                        />
                      </Grid>

                        <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Passcode
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Passcode"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="frenchise_password"
                          value={this.state.frenchise_password}
                          onChange={this.handleChange}
                        />
                      </Grid>
                    </Grid>

                    <br />
                    <br />
                    <br/>

                    <Box>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none", fontSize: 12 }}
                        onClick={this.updateFrenchise}
                      >
                        Edit Franchise Details
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Box>

              <br />
              <br />
              <br />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default EditFranchise;

export function EditFranchisec(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return <EditFranchise param={param} navigate={navigate}></EditFranchise>;
}



